import Input from '@/components/form/input';
import {DocumentInputField} from '@/engine/types';
import {FieldProps} from '../../meta-field';

export const HiddenField = ({field, value}: FieldProps<DocumentInputField>) => {
  return <Input data-testid={`${field.id}_input`} readOnly name={field.id} type="hidden" value={value} />;
};
